import { Contact } from './contact'
import { User } from './user'
import { IPagination, IQueryParams } from './common'

export interface IGroupQueryParams extends IQueryParams {
  createTime?: string,
  insCode?: string,
  insName?: string,
  agentCode?: string,
  agentName?: string,
}

export class AgentFull {
  agent: Agent
  users: User[] = []
  constructor() {
    this.agent = new Agent()
  }
}

export class Agent {
  common: GroupCommon
  version?: number
  createdAt?: string
  updatedAt?: string

  constructor() {
    this.common = new GroupCommon()
  }
}

export class GroupCommon {
  /* æ°çæ¥å£ */
  insCode: string
  insName: string
  insNameEN: string
  agentCode: string
  agentName: string // éå¢ï¼æ¬å°ï¼åç§°
  agentNameEN: string // éå¢è±æåç§°
  contact: Contact
  status: string

  /* æ§çæ¥å£ */
  agentNum: string
  createdAt: string
  updatedAt: string
  users: User[] // è¯¥å­æ®µåªæå¨æ°å»ºéå¢çæ¶åæç¨

  constructor() {
    this.contact = new Contact()
    // this.users = []
  }
}

export interface IGroupPagination extends IPagination {
  data: Agent[]
}
